import {IconButton, Tooltip, Whisper} from "rsuite";
import {Reload} from "@rsuite/icons";
import React from "react";
import {UpdateButtonProps} from "./UpdateButton.model";

const UpdateButton = ({loading, onRefresh, tooltip = 'Обновить данные'}: UpdateButtonProps) => {
  return (
    <Whisper
      placement="top"
      speaker={<Tooltip>{tooltip}</Tooltip>}
    >
      <IconButton
        icon={<Reload />}
        size="sm"
        loading={loading}
        onClick={onRefresh}
        className="refresh-btn"
      />
    </Whisper>
  )
}

export default UpdateButton;
